<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'app',
  methods: {
    ...mapActions(['onLogin']),
  },
  beforeMount () {
    if (window.sessionStorage.getItem('token') && !WebIM.conn.isOpened()) {
      WebIM.conn.close && WebIM.conn.close();
      const _this = this
      const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        _this.onLogin({
          username: userInfo.userId,
          password: userInfo.password
        })
      }
    }
  }
}
</script>

<style>
@import url("@/utils/theme/base.css");
</style>